import { installTzdataConversions } from "./install-tzdata-conversions";
import { installTzdataZones } from "./install-tzdata-zones";

installTzdataZones();
installTzdataConversions();

export { installTzdataConversions } from "./install-tzdata-conversions";
export { installTzdataZones } from "./install-tzdata-zones";
export { getTimezoneOffset, tzdataVersion } from "./timezone-data";
